import { useEffect } from "react";
import { X } from "lucide-react";
import { IMAGES } from "@/lib/site";

const DOCS = {
  gaf: {
    src: IMAGES.gafCertificate,
    alt: "2026 GAF Certified Roofing Contractor certificate — Everstone Roofing Inc",
    caption: null,
    key: "gaf-certificate",
  },
  license: {
    src: IMAGES.wiLicense,
    alt: "Wisconsin Dwelling Contractor Qualifier license NO. 5492-DCQ — personal details redacted",
    caption: "Verify at dsps.wi.gov → License Lookup · #5492-DCQ",
    key: "wi-license",
  },
};

export default function CredentialModal({ doc, onClose }) {
  useEffect(() => {
    if (!doc) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [doc, onClose]);

  if (!doc) return null;
  const d = DOCS[doc];

  return (
    <div
      data-testid="credential-modal"
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm"
      onClick={onClose}
    >
      <button
        type="button"
        onClick={onClose}
        data-testid="credential-modal-close"
        aria-label="Close"
        className="absolute top-4 right-4 z-10 inline-flex items-center justify-center w-11 h-11 border border-[#D4A84B]/50 bg-[#101010] text-white hover:text-[#FFBF00] hover:border-[#FFBF00] transition-colors"
      >
        <X className="w-5 h-5" />
      </button>

      <div
        className="relative w-full h-full sm:w-auto sm:h-auto sm:max-w-3xl sm:max-h-[92vh] overflow-auto bg-[#101010] sm:border sm:border-[#2E3036] flex flex-col items-center justify-center p-4 sm:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={d.src}
          alt={d.alt}
          data-testid={`credential-modal-image-${d.key}`}
          className="max-w-full max-h-[78vh] w-auto h-auto object-contain bg-white"
        />
        {d.caption && (
          <p
            data-testid="credential-modal-caption"
            className="mt-4 text-white/60 text-xs sm:text-sm text-center"
          >
            {d.caption}
          </p>
        )}
      </div>
    </div>
  );
}
